import API_ROOT from '../../../utils/api';
import securedAxios from '../../../utils/secured-axios';

import * as IUser from '../../../interfaces/users';

export const fetchUsersMe = async () => {
  try {
    const { data } = await securedAxios.get<IUser.MeResponse>(
      `${API_ROOT}/users/me`,
    );
    return data;
  } catch (e) {
    return;
  }
};

export const fetchUsersSubscription = async (productId: string) => {
  try {
    const { data } = await securedAxios.get<IUser.SubscriptionResponse>(
      `${API_ROOT}/users/me/products/${productId}/subscription`,
    );
    return data;
  } catch (e) {
    return;
  }
};
